/**
 * Global Navigation Service for React Router v6 compatibility with Redux Sagas
 * 
 * This service provides a bridge between sagas (which can't directly access useNavigate)
 * and React Router v6 navigation. The navigator is set once in the root component.
 */

// Use a simple object to store navigation functions - more reliable than class static
const navigationState = {
  navigate: null,
  location: null
};

class NavigationService {
  /**
   * Set the navigate function from useNavigate hook
   * Called once in the root component
   */
  static setNavigator(navigate, location) {
    navigationState.navigate = navigate;
    navigationState.location = location;
  }

  /**
   * Navigate to a route (replaces history.push)
   * Can be called from sagas or anywhere in the app
   */
  /**
   * Navigate to a route (replaces history.push)
   * Can be called from sagas or anywhere in the app
   */
  static push(route) {
    if (navigationState.navigate && route) {
      // Handle routes with query parameters properly for React Router v6
      if (route.includes('?')) {
        const [pathname, search] = route.split('?');
        navigationState.navigate({ pathname, search: '?' + search });
      } else {
        navigationState.navigate(route);
      }
    } else {
      console.warn('NavigationService: Navigator not set or route is empty', { 
        route, 
        navigate: !!navigationState.navigate
      });
    }
  }

  /**
   * Go back to previous page (replaces history.goBack)
   * Can be called from sagas or anywhere in the app
   */
  static goBack() {
    if (navigationState.navigate) {
      navigationState.navigate(-1);
    } else {
      console.warn('NavigationService: Navigator not set');
    }
  }

  /**
   * Replace current route (replaces history.replace)
   */
  static replace(route) {
    if (navigationState.navigate && route) {
      navigationState.navigate(route, { replace: true });
    } else {
      console.warn('NavigationService: Navigator not set or route is empty', { route, navigate: !!navigationState.navigate });
    }
  }

  /**
   * Get current location (for sagas that need current path)
   */
  static getCurrentLocation() {
    return navigationState.location;
  }
}

export default NavigationService;
